// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.age-verification {
  --ion-background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.close-button-container {
  display: flex;
  justify-content: flex-end;
  width: 100%;
}

.message {
  text-align: center;
  margin: 2rem 0;
}

.message h2 {
  font-size: 1.5rem;
  color: #333333;
  font-weight: bold;
}

.message p {
  font-size: 1rem;
  color: #333333;
  padding: 0 1rem;
}

.buttons ion-button {
  margin: 0.5rem 0;
}

.title {
  margin-top: 1rem;
  font-size: 1.5rem;
  color: var(--ion-color-secondary);
  font-weight: bold;
}

.button-row {
  padding: 0 1rem;
  display: flex;
  justify-content: center;
  gap: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/age-verification/age-verification.component.scss"],"names":[],"mappings":"AACA;EACI,+BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,kBAAA;AAAJ;;AAGE;EACE,aAAA;EACA,yBAAA;EACA,WAAA;AAAJ;;AAGE;EACE,kBAAA;EACA,cAAA;AAAJ;;AAGE;EACE,iBAAA;EACA,cAAA;EACA,iBAAA;AAAJ;;AAIE;EACE,eAAA;EACA,cAAA;EACA,eAAA;AADJ;;AAIE;EACE,gBAAA;AADJ;;AAKA;EACE,gBAAA;EACA,iBAAA;EACA,iCAAA;EACA,iBAAA;AAFF;;AAKA;EACE,eAAA;EACA,aAAA;EACA,uBAAA;EACA,SAAA;AAFF","sourcesContent":["\n.age-verification {\n    --ion-background-color: #ffffff;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n  }\n\n  .close-button-container {\n    display: flex;\n    justify-content: flex-end;\n    width: 100%;\n  }\n  \n  .message {\n    text-align: center;\n    margin: 2rem 0;\n  }\n  \n  .message h2 {\n    font-size: 1.5rem;\n    color: #333333;\n    font-weight: bold;\n  }\n  \n  \n  .message p {\n    font-size: 1rem;\n    color: #333333;\n    padding: 0 1rem;\n  }\n  \n  .buttons ion-button {\n    margin: 0.5rem 0;\n  }\n  \n  \n.title {\n  margin-top: 1rem;\n  font-size: 1.5rem;\n  color: var(--ion-color-secondary);\n  font-weight: bold;\n}\n\n.button-row {\n  padding: 0 1rem;\n  display: flex;\n  justify-content: center;\n  gap: 1rem;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
